(() => {
    const GLOBAL_INIT_KEY = '__s1_4wd_whats_in_box_swiper_registered__';
    if (window[GLOBAL_INIT_KEY]) return;
    window[GLOBAL_INIT_KEY] = true;

    class S14wdWhatsInBoxSwiperSection extends HTMLElement {
        connectedCallback() {
            this.initSwiperWithRetry();
        }

        disconnectedCallback() {
            if (this.swiper?.destroy) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }

        initSwiperWithRetry() {
            let attempts = 0;
            const maxAttempts = 20;
            const intervalMs = 200;

            const timer = window.setInterval(() => {
                attempts += 1;
                if (this.initSwiper() || attempts >= maxAttempts) {
                    window.clearInterval(timer);
                }
            }, intervalMs);
        }

        initSwiper() {
            if (this.dataset.swiperInited === 'true') return true;
            if (!window.Swiper) return false;

            const swiperEl = this.querySelector('.s1-4wd-whats-in-box-swiper-items-content.swiper');
            if (!swiperEl) return true;

            const slides = swiperEl.querySelectorAll('.swiper-slide');
            if (!slides.length) return true;

            this.tabs = Array.from(
                this.querySelectorAll('.s1-4wd-whats-in-box-swiper-item-tab[data-slide-index]')
            );

            this.swiper = new window.Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 400,
                allowTouchMove: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true,
                },
                watchOverflow: true,
                on: {
                    slideChange: () => {
                        this.setActiveTab(this.swiper.activeIndex);
                    },
                },
            });

            this.tabs.forEach((tab) => {
                tab.addEventListener('click', () => {
                    const index = parseInt(tab.dataset.slideIndex, 10);
                    if (Number.isNaN(index)) return;
                    this.swiper.slideTo(index);
                    this.setActiveTab(index);
                });
            });

            this.setActiveTab(this.swiper.activeIndex);
            this.dataset.swiperInited = 'true';
            return true;
        }

        setActiveTab(index) {
            this.tabs.forEach((tab) => {
                const tabIndex = parseInt(tab.dataset.slideIndex, 10);
                tab.classList.toggle('active', tabIndex === index);
            });
        }
    }

    if (!customElements.get('s1-4wd-whats-in-box-swiper-section')) {
        customElements.define('s1-4wd-whats-in-box-swiper-section', S14wdWhatsInBoxSwiperSection);
    }
})();
